import { render, staticRenderFns } from "./i-paginator.vue?vue&type=template&id=3f70e5d9&scoped=true&"
import script from "./i-paginator.vue?vue&type=script&lang=js&"
export * from "./i-paginator.vue?vue&type=script&lang=js&"
import style0 from "./i-paginator.vue?vue&type=style&index=0&id=3f70e5d9&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f70e5d9",
  null
  
)

export default component.exports